import React from "react";
import {useNavigate} from "react-router-dom";
import "./ErrorPage.css";

interface Props {
    onRetry?: () => void;
}

const ErrorPage: React.FC<Props> = ({onRetry}) => {
    const navigate = useNavigate();

    return (
        <div className="errorPage">
            <div className="errorCard">
                <div className="errorIcon">⚠️</div>
                <h2 className="errorTitle">Une erreur est survenue</h2>
                <p className="errorMessage">
                    Un problème inattendu s'est produit sur cette page.<br/>
                    Vous pouvez réessayer ou revenir à l'accueil.
                </p>
                <div className="errorActions">
                    {onRetry && (
                        <button className="errorButtonPrimary" onClick={onRetry}>
                            Réessayer
                        </button>
                    )}
                    <button className="errorButtonSecondary" onClick={() => navigate("/")}>
                        Retour à l'accueil
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;